import { Box, Typography } from "@material-ui/core"
import React from "react"
import { useStyles } from "./pedido-valor-styles"
import { toDecimalString } from "utils/to-decimal"

export type PedidoValorProps = {
    valorTotalPedido: number
    valorTotalServico?: number
    valorTotalFrete?: number
    valorTotalAcrescimo?: number
    valorTotalDesconto?: number
    valorSubTotal: number
}

export const PedidoValor = ({ valorTotalPedido, valorTotalServico, valorTotalFrete, valorTotalAcrescimo, valorTotalDesconto, valorSubTotal }: PedidoValorProps) => {
    const classes = useStyles()

    return (
        <>
            <Typography variant="caption" color="textSecondary">
                <Box fontWeight={600} mb={2}>
                    Valores do Pedido
                </Box>
            </Typography>
            <Box className={classes.valores}>
                <Typography variant="body2">
                    Subtotal
                </Typography>
                <Typography variant="body2">
                    R$ {toDecimalString(valorSubTotal)}
                </Typography>
            </Box>
            {!!valorTotalFrete && (
                <Box className={classes.valores}>
                    <Typography variant="body2">
                        Frete
                    </Typography>
                    <Typography variant="body2">
                        R$ {toDecimalString(valorTotalFrete)}
                    </Typography>
                </Box>
            )}
            {!!valorTotalAcrescimo && (
                <Box className={classes.valores}>
                    <Typography variant="body2">
                        Acréscimo
                    </Typography>
                    <Typography variant="body2">
                        R$ {toDecimalString(valorTotalAcrescimo)}
                    </Typography>
                </Box>
            )}
            {!!valorTotalDesconto && (
                <Box className={classes.valores}>
                    <Typography variant="body2">
                        Desconto
                    </Typography>
                    <Typography variant="body2">
                        R$ {toDecimalString(valorTotalDesconto)}
                    </Typography>
                </Box>
            )}
            {!!valorTotalServico && (
                <Box className={classes.valores}>
                    <Typography variant="body2">
                        Serviço
                    </Typography>
                    <Typography variant="body2">
                        R$ {toDecimalString(valorTotalServico)}
                    </Typography>
                </Box>
            )}
            <Box className={classes.valores} mt={1}>
                <Typography variant="body2">
                    <Box fontWeight={600}>
                        Total
                    </Box>
                </Typography>
                <Typography variant="body2">
                    <Box fontWeight={600}>
                        R$ {toDecimalString(valorTotalPedido)}
                    </Box>
                </Typography>
            </Box>
        </>
    )
}